import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../../../shared/components/layout/Layout';

const PrivacyPolicyPage = () => {
    const { t } = useTranslation();

    return (
        <Layout title={t('legal.privacy.title')} showAuthLinks={false}>
            <div className="max-w-3xl mx-auto space-y-8 text-gray-700">
                <p className="text-sm text-gray-500">
                    {t('legal.privacy.lastUpdated', { date: new Date() })}
                </p>

                <section className="space-y-4">
                    <h2 className="text-xl font-bold text-gray-900">{t('legal.privacy.sections.intro.title')}</h2>
                    <p>{t('legal.privacy.sections.intro.body')}</p>
                </section>

                <section className="space-y-4">
                    <h2 className="text-xl font-bold text-gray-900">{t('legal.privacy.sections.responsible.title')}</h2>
                    <div className="bg-gray-50 p-4 rounded-lg text-sm">
                        <p><strong>{t('legal.privacy.sections.responsible.name')}</strong> Albert Ramos Pastor</p>
                        <p><strong>{t('legal.privacy.sections.responsible.nif')}</strong> 47977582L</p>
                        <p><strong>{t('legal.privacy.sections.responsible.address')}</strong> C/ Lepant 270</p>
                        <p><strong>{t('legal.privacy.sections.responsible.email')}</strong> hola@heaful.app</p>
                    </div>
                </section>

                <section className="space-y-4">
                    <h2 className="text-xl font-bold text-gray-900">{t('legal.privacy.sections.purpose.title')}</h2>
                    <p className="mb-3">{t('legal.privacy.sections.purpose.intro')}</p>
                    <ul className="list-disc pl-6 space-y-2">
                        <li>{t('legal.privacy.sections.purpose.items.service')}</li>
                        <li>{t('legal.privacy.sections.purpose.items.communication')}</li>
                        <li>{t('legal.privacy.sections.purpose.items.improvement')}</li>
                        <li>{t('legal.privacy.sections.purpose.items.security')}</li>
                    </ul>
                </section>

                <section className="space-y-4">
                    <h2 className="text-xl font-bold text-gray-900">{t('legal.privacy.sections.data.title')}</h2>
                    <p className="mb-3">{t('legal.privacy.sections.data.intro')}</p>
                    <ul className="list-disc pl-6 space-y-2">
                        <li><strong>{t('legal.privacy.sections.data.items.identification.title')}</strong> {t('legal.privacy.sections.data.items.identification.desc')}</li>
                        <li><strong>{t('legal.privacy.sections.data.items.preferences.title')}</strong> {t('legal.privacy.sections.data.items.preferences.desc')}</li>
                        <li><strong>{t('legal.privacy.sections.data.items.usage.title')}</strong> {t('legal.privacy.sections.data.items.usage.desc')}</li>
                        <li><strong>{t('legal.privacy.sections.data.items.technical.title')}</strong> {t('legal.privacy.sections.data.items.technical.desc')}</li>
                    </ul>
                </section>

                <section className="space-y-4">
                    <h2 className="text-xl font-bold text-gray-900">{t('legal.privacy.sections.lawful.title')}</h2>
                    <p className="mb-3">{t('legal.privacy.sections.lawful.intro')}</p>
                    <ul className="list-disc pl-6 space-y-2">
                        <li><strong>{t('legal.privacy.sections.lawful.items.consent.title')}</strong> {t('legal.privacy.sections.lawful.items.consent.desc')}</li>
                        <li><strong>{t('legal.privacy.sections.lawful.items.contract.title')}</strong> {t('legal.privacy.sections.lawful.items.contract.desc')}</li>
                        <li><strong>{t('legal.privacy.sections.lawful.items.legitimate.title')}</strong> {t('legal.privacy.sections.lawful.items.legitimate.desc')}</li>
                    </ul>
                </section>

                <section className="space-y-4">
                    <h2 className="text-xl font-bold text-gray-900">{t('legal.privacy.sections.recipients.title')}</h2>
                    <p className="mb-3">{t('legal.privacy.sections.recipients.body')}</p>
                    <ul className="list-disc pl-6 space-y-2">
                        <li>{t('legal.privacy.sections.recipients.items.hosting')}</li>
                        <li>{t('legal.privacy.sections.recipients.items.analytics')}</li>
                        <li>{t('legal.privacy.sections.recipients.items.legal')}</li>
                    </ul>
                </section>

                <section className="space-y-4">
                    <h2 className="text-xl font-bold text-gray-900">{t('legal.privacy.sections.retention.title')}</h2>
                    <p>{t('legal.privacy.sections.retention.body')}</p>
                </section>

                <section className="space-y-4">
                    <h2 className="text-xl font-bold text-gray-900">{t('legal.privacy.sections.rights.title')}</h2>
                    <p className="mb-3">{t('legal.privacy.sections.rights.intro')}</p>
                    <ul className="list-disc pl-6 space-y-2">
                        <li><strong>{t('legal.privacy.sections.rights.items.access')}</strong></li>
                        <li><strong>{t('legal.privacy.sections.rights.items.rectification')}</strong></li>
                        <li><strong>{t('legal.privacy.sections.rights.items.deletion')}</strong></li>
                        <li><strong>{t('legal.privacy.sections.rights.items.limitation')}</strong></li>
                        <li><strong>{t('legal.privacy.sections.rights.items.portability')}</strong></li>
                        <li><strong>{t('legal.privacy.sections.rights.items.opposition')}</strong></li>
                        <li><strong>{t('legal.privacy.sections.rights.items.withdraw')}</strong></li>
                    </ul>
                </section>

                <section className="space-y-4">
                    <h2 className="text-xl font-bold text-gray-900">{t('legal.privacy.sections.security.title')}</h2>
                    <p>{t('legal.privacy.sections.security.body')}</p>
                </section>

                <section className="space-y-4">
                    <h2 className="text-xl font-bold text-gray-900">{t('legal.privacy.sections.contact.title')}</h2>
                    <p className="mb-2">{t('legal.privacy.sections.contact.body')}</p>
                    <div className="bg-indigo-50 p-4 rounded-lg text-sm">
                        <p><strong>Email:</strong> hola@heaful.app</p>
                        <p className="mt-2 text-gray-600">{t('legal.privacy.sections.contact.note')}</p>
                    </div>
                </section>
            </div>
        </Layout>
    );
};

export default PrivacyPolicyPage;


